import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { user } from '@/ui/auth/auth';
  import ContactUsModal from '@/ui/pages/subscription/Chargebee/details/ContactUsModal.vue';
  import { useModal } from '@/ui/concerns/modals/useModal';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiCredits',
  setup(__props) {

  const [showContactUsModal, onContactUsClick, onContactUsClose] = useModal();

  const usedCredits = computed(() => {
    const monthly = user.value?.aiWallet?.monthly || 0;
    const available = user.value?.aiWallet?.available || 0;
    return monthly - available;
  });

  const totalCredits = computed(() => {
    return user.value?.aiWallet?.monthly || 0;
  });

return { __sfc: true,showContactUsModal, onContactUsClick, onContactUsClose, usedCredits, totalCredits, Box, ContactUsModal }
}

})